
<div class="modal-body">
    <div class="row">
        <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="customer_detail">
                <p>Customer Name: <span>{{InvoiceDetails?.customer?.FirstName}} {{InvoiceDetails?.customer?.LastName}}</span> </p>
            </div>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-3 pl-0">
            <div class="customer_detail">
                <p>Account Nuumber: <span>{{InvoiceDetails?.customer?.AccountNumber}}</span> </p>
            </div>
        </div>
        <div class="col-sm-6 col-mg-6 col-lg-">
            <div class="modelclasebtn ">
     
                <button type="button" class="close" aria-label="Close" (click)="onClose()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-md-6 col-lg-6">
            <div class="acc_detail">
                <p>Customer transactions sorted by Drop Date:</p>
            </div>
        </div>
      

    <div class="panel_table">
        <div class="panel panel-default ">
            <div class="table-responsive pull-left max-width margin-top-10">
                <table class="table table-bordered table-striped">
                    <thead class="tableHeader">
                        <tr>

                            <th>No.</th>
                            <th>Drop Date</th>
                            <th>Invoice #</th>
                            <th>Date Due</th>
                            <th>Status</th>
                            <th>Pickup Date</th>
                            <th>Loc</th>
                            <th>Pcs</th>
                            <th>Class</th>
                            <th>Total</th>
                            <th>Lot</th>
                            <th>Tag</th>
                            <th>Invoice Id</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let InvoiceDetail of InvoiceDetails?.transactionDeatils; let i = index;">
                            <td>{{i+1}}</td>
                            <td>{{InvoiceDetail?.DropDate | date: 'MM/dd/yyyy hh:mm:ss'}}</td>
                            <td>{{InvoiceDetail?.InvoiceNo}}</td>
                            <td>{{InvoiceDetail?.DueDate | date: 'MM/dd/yyyy hh:mm:ss'}}</td>
                            <td>{{InvoiceDetail?.Status}}</td>
                            <td [ngStyle]="{'text-align': (InvoiceDetail?.PickupDate === null) ? 'center' : 'left'}">{{InvoiceDetail?.PickupDate === null ? '-' : InvoiceDetail?.PickupDate | date: 'MM/dd/yyyy hh:mm:ss'}}</td>
                            <td>{{InvoiceDetail?.Location}}</td>
                            <td>{{InvoiceDetail?.NoOfPieces}}</td>
                            <td>{{InvoiceDetail?.ClassCode}}</td>
                            <td>{{InvoiceDetail?.SalePrice}}</td>
                            <td>{{InvoiceDetail?.LotNumber}}</td>
                            <td>{{InvoiceDetail?.TagStart}}</td>
                            <td>{{InvoiceDetail?.InvoiceId}}</td>
                            
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="InvoiceDetails?.PaginatedResult?.TotalRecords > 10" style="float: right;">
                    <ngb-pagination [(page)]="PageNo" [maxSize]="10"
                        [collectionSize]="InvoiceDetails?.PaginatedResult?.TotalRecords" [ellipses]="true"
                        [boundaryLinks]="true" (pageChange)="getInvoiceDetails($event)">
                    </ngb-pagination>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="customer_detail">
                <p>Invoice Total: <span>${{InvoiceDetails?.InvoiceTotal}}</span> </p>
            </div>
        </div>
        <!-- <div class="col-sm-3 col-md-3 col-lg-3 pl-0">
            <div class="customer_detail">
                <p>Refund Total: <span>$0.00</span> </p>
            </div>
        </div> -->
    </div>
</div>
